import React, { useEffect, useState } from "react";
import {
  AttachFile,
  DeleteOutlined,
  ErrorOutlineOutlined,
} from "@mui/icons-material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { AiOutlineDelete } from "react-icons/ai";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";

// import RiskDrawer from "../../NewQuestionTabComps/RightSection/riskDrawer/RiskDrawer";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  TextField,
} from "@mui/material";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const MultiChoice = ({
  questionId,
  option,
  checkBoxOption,
  setCheckBoxOption,
  submittedAnswer,
  removeEditOption,
  handleQuesAnswer,
  questionType,
  isFrom,
  event,
  comment,
  usingQues,
  linkageAnswer,
  selectedQues,
  question,
  hasAttachedDocument,
  configuration = false
}) => {
  // const { selectedOption } = useSelector((state) => state?.corporateSurvey);

  // const checkBoxOptionArray = [
  //   { option: "option 1", checked: false },
  //   { option: "option 2", checked: false },
  // ];

  const isEditing = selectedQues?._id === usingQues?._id;

  const checkBoxOptionArray = [
    { option: "option 1", weight: 1 },
    { option: "option 2", weight: 2 },
  ];

  // use in add / update
  useEffect(() => {
    if (checkBoxOption?.length === 0 && !submittedAnswer) {
      if (
        usingQues?.questionType === "ZERO_TO_TEN" ||
        usingQues?.questionType === "LIKERT" ||
        usingQues?.questionType === "SATISFACTION" ||
        usingQues?.questionType === "QUALITY" ||
        usingQues?.questionType === "FREQUENCY" ||
        usingQues?.questionType === "PERFORMANCE" ||
        usingQues?.questionType === "IMPORTANCE" ||
        usingQues?.questionType === "EMOTIONS" ||
        usingQues?.questionType === "TABLE"
      ) {
        setCheckBoxOption(checkBoxOptionArray);
      } else {
        setCheckBoxOption(option || checkBoxOptionArray);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [editingIndex, setEditingIndex] = React.useState(null);
  const [editedText, setEditedText] = React.useState("");
  const [optionsArray, setOptionsArray] = useState([]);
  const [commentBox, setCommentBox] = useState("");

  const [attachDocument, setAttachDocument] = useState(null);

  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [riskData, setRiskData] = useState({
    description: "",
    enableCompensationControl: false,
    finding: "",
    risk: "",
    severity: "",
  });

  const [optionIndex, setOptionIndex] = useState(null);
  const [compensationStatement, setCompensationStatement] = useState("");

  let handleOption = checkBoxOption || option;

  useEffect(() => {
    // Determine source for initializing
    const source =
      submittedAnswer?.[0]?.options || checkBoxOption || option || [];

    // Initialize with checked flags
    const initialized = source.map((opt) => ({
      ...opt,
      checked: opt.checked || false,
    }));

    setOptionsArray(initialized);

    if (submittedAnswer?.[0]?.comment) {
      setCommentBox(submittedAnswer[0].comment);
    }

    setAttachDocument(submittedAnswer?.[0]?.supporting_document || null);
  }, [checkBoxOption, option]);

  const handleChange = (e, index) => {
    const { checked, name, value, type } = e.target;

    if (type === "checkbox") {
      const updatedOptions = optionsArray?.map((opt, i) =>
        i === index ? { ...opt, checked } : opt
      );
      setOptionsArray(updatedOptions);
      handleQuesAnswer({
        obj: {
          options: updatedOptions,
          comment: commentBox,
          supporting_document: attachDocument,
        },
        realQuestion: question,
      });
    } else if (name === "comment") {
      setCommentBox(value);
      handleQuesAnswer({
        obj: {
          options: optionsArray,
          comment: value,
          supporting_document: attachDocument,
        },
        realQuestion: question,
      });
    }
  };

  const handleChangeDoc = (type, value) => {
    setAttachDocument(value);

    const obj = {
      options: optionsArray,
      comment: commentBox,
      supporting_document:
        type === "document" && value === null ? value : attachDocument,
      document: type === "document" ? value : attachDocument,
      documentMetaData:
        type === "document"
          ? {
              ques_id: question?._id,
              name: value?.name,
              is_supporting_document: true,
              type: value?.type,
            }
          : null,
      weightage: 1,
    };
    handleQuesAnswer({ obj, realQuestion: question });
  };

  const handleAddOption = () => {
    setCheckBoxOption((preValue) => [
      ...preValue,
      {
        option: `option ${preValue.length + 1}`,
        // checked: false,
        weight: preValue.length + 1,
      },
    ]);
  };

  const handleDoubleClick = (index, currentLabel) => {
    setEditingIndex(index);
    setEditedText(currentLabel);
  };

  const handleLabelBlur = (index) => {
    setEditingIndex(null);

    const updatedOptions = checkBoxOption.map((option, i) => {
      if (i === index) {
        return { ...option, option: editedText };
      }
      return option;
    });

    setCheckBoxOption(updatedOptions);
  };

  const handleLabelChange = (event) => {
    setEditedText(event.target.value);
  };

  const handleMapRiskData = (i) => {
    if (isFrom === "surveyCreation") {
      setRiskData(checkBoxOption[i]?.questionRisk);
    }
  };

  const handleToggleRiskDrawer = () => {
    setToggleDrawer(false);
  };

  const handleRiskData = (e) => {
    setCheckBoxOption((prev) =>
      prev?.map((item, i) => {
        if (i === optionIndex) {
          return {
            ...item,
            questionRisk: {
              ...item?.questionRisk,
              [e.target.name]: e.target.value ? e.target.value : "",
              // description:
              //   e.target.name === "description" ? e.target.value : "",
              // finding: e.target.name === "finding" ? e.target.value : "",
              // risk: e.target.name === "risk" ? e.target.value : "",
              // severity: e.target.name === "severity" ? e.target.value : "",
              enableCompensationControl: e.target.checked ? true : false,
            },
          };
        }
        return item;
      })
    );

    if (e.target.name === "enableCompensationControl") {
      setRiskData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setRiskData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  return (
    <Box>
      <Box
        sx={
          configuration
            ? {
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                padding: 2,
                // maxWidth: 700,
                margin: "20px auto",
                backgroundColor: "#ebf1f8",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                display: "flex", flexDirection: "column"
              }
            : { display: "flex", flexDirection: "column" }
        }
      >
        <FormControl component="fieldset">
          <FormGroup>
            {optionsArray &&
              optionsArray.map((option, index) => (
                <Box key={index}>
                  {editingIndex === index ? (
                    <TextField
                      type="text"
                      value={editedText}
                      onChange={handleLabelChange}
                      onBlur={() => handleLabelBlur(index)}
                      autoFocus
                    />
                  ) : (
                    <>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          // width: "60vw",
                          pointerEvents: event,
                        }}
                      >
                        <FormControlLabel
                          control={
                            <>
                              <Checkbox
                                disabled={isFrom !== "taskSection"}
                                size="small"
                                style={{
                                  color: "#3374B9",
                                  pointerEvents: event,
                                }}
                                checked={
                                  optionsArray?.[index]?.checked || false
                                }
                                onChange={(event) => handleChange(event, index)}
                                name={option.option}
                              />
                            </>
                          }
                          label={
                            <Box style={{ wordBreak: "break-all" }}>
                              {option.option}
                            </Box>
                          }
                          onDoubleClick={() =>
                            !submittedAnswer &&
                            !removeEditOption &&
                            handleDoubleClick(index, option.option)
                          }
                        />

                        {!submittedAnswer && !removeEditOption && isEditing && (
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            gridGap={"20px"}
                            style={{ marginRight: "10px" }}
                          >
                            {/* <ErrorOutlineOutlined
                                onClick={() => {
                                  setToggleDrawer(true);
                                  setOptionIndex(index);
                                  handleMapRiskData(index);
                                }}
                                style={{
                                  color: !option?.questionRisk
                                    ? "#3374B9"
                                    : "#B81D13",
                                  cursor: "pointer",
                                }}
                              /> */}

                            <AiOutlineDelete
                              onClick={() =>
                                setCheckBoxOption((preValue) =>
                                  preValue.filter((option, i) => i !== index)
                                )
                              }
                              style={{ color: "#C45446", cursor: "pointer" }}
                            />
                          </Box>
                        )}
                      </Box>
                      {/* {((index === optionIndex &&
                          option?.questionRisk?.enableCompensationControl &&
                          isFrom !== "surveyCreation") ||
                          (submittedAnswer?.length > 0 &&
                            submittedAnswer[0]?.option === option?.option)) && (
                          <Box
                            display={"flex"}
                            flexDirection={"column"}
                            gridGap={7}
                            mb={1}
                            ml={3}
                          >
                            {(option?.questionRisk?.enableCompensationControl ||
                              submittedAnswer[0]?.riskCompensationStatement) && (
                              <TextField
                                fullWidth
                                id="comment"
                                label="Compensation Statement"
                                variant="outlined"
                                multiline
                                minRows={2}
                                // placeholder="Compensation comment"
                                style={{ marginTop: "10px" }}
                                value={compensationStatement}
                                // defaultValue={usingQues?.commentBox}
                                onChange={(e) =>
                                  setCompensationStatement(e.target.value)
                                }
                              />
                            )}
                          </Box>
                        )} */}
                    </>
                  )}
                </Box>
              ))}
          </FormGroup>

          {!submittedAnswer &&
            !removeEditOption &&
            handleOption?.length > 0 &&
            isEditing && (
              <FormHelperText>Double Click to Edit Option</FormHelperText>
            )}
        </FormControl>
        {!submittedAnswer && !removeEditOption && isEditing && (
          <Button
            sx={{ width: "35%" }}
            variant="outlined"
            color="primary"
            onClick={() => handleAddOption()}
          >
            Add Option
          </Button>
        )}
      </Box>
      {comment && (
        <Box
          style={{
            pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
          }}
        >
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) =>
              handleChange({ target: { name, value } })
            }
          />
        </Box>
      )}

      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChangeDoc}
            question={"document"}
          />
        </Box>
      )}

      {/* <RiskDrawer
        toggleDrawer={toggleDrawer}
        handleToggleRiskDrawer={handleToggleRiskDrawer}
        setRiskData={setRiskData}
        handleRiskData={handleRiskData}
        riskData={riskData}
      /> */}
    </Box>
  );
};

export default MultiChoice;
